import { getAnnouncementBanner } from 'api/services';
import useDataQuery from 'modules/shared/hooks/useDataQuery';

const useAnnouncementBannerData = () => {
    const announcementBannerQuery = useDataQuery(['announcementBanner'], () => getAnnouncementBanner(), {
        staleTime: 2 * 60 * 60 * 1000, // 2 hours → considered fresh
        refetchInterval: 2 * 60 * 60 * 1000, // refetch every 2 hours
    });

    return {
        isLoading: announcementBannerQuery.isLoading,
        announcementBanner: announcementBannerQuery.data,
    };
};

export default useAnnouncementBannerData;
